export default "__VITE_ASSET__DZ8qT9qL__"